export default "__VITE_ASSET__aae7a198__"